var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
  marginLeft: _vm.marginLeft + 'px',
  marginBottom: _vm.marginBottom + 'px',
  marginTop: _vm.marginTop + 'px',
  width: _vm.styleWidth
})},[_c('p',{staticClass:"static-tips",domProps:{"innerHTML":_vm._s(_vm.getCont())}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4507deb5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/staticTips/index.vue
// module id = null
// module chunks = 